import { formatAddressLocality } from '../lib/format-address-locality';
import { formatAddressStreet } from '../lib/format-address-street';
import { formatPronouns } from '../lib/format-pronouns';
import { formatTimeZone } from '../lib/format-time-zone';
import type { GetClientProfileOutput, GetContactProfileOutput } from '../model/client.types';
import { ProfileDetailsFlag } from './profile-details/profile-details-flag';
import { ProfileDetailsRow } from './profile-details/profile-details-row';
import { ProfileDetailsValue } from './profile-details/profile-details-value';

type Props = {
    profile: Pick<
        GetClientProfileOutput & GetContactProfileOutput,
        | 'firstName'
        | 'lastName'
        | 'okToEmail'
        | 'okToCallText'
        | 'timeZone'
        | 'address'
        | 'pronouns'
    >;
};

export function ProfileDetails({ profile }: Props) {
    const { okToEmail, okToCallText } = profile;

    return (
        <dl>
            <ProfileDetailsRow label="Legal name">
                <ProfileDetailsValue lines={[`${profile.firstName} ${profile.lastName}`]} />
            </ProfileDetailsRow>
            <ProfileDetailsRow label="Contact preferences">
                {okToEmail === null && okToCallText === null ? (
                    <ProfileDetailsValue lines={[]} />
                ) : (
                    <>
                        {okToEmail === null ? (
                            <ProfileDetailsValue lines={[]} />
                        ) : (
                            <ProfileDetailsFlag
                                isPositive={okToEmail}
                                positiveText="Ok to email"
                                negativeText="Do NOT email"
                            />
                        )}
                        {okToCallText === null ? (
                            <ProfileDetailsValue lines={[]} />
                        ) : (
                            <ProfileDetailsFlag
                                isPositive={okToCallText}
                                positiveText="Ok to call or text"
                                negativeText="Do NOT call or text"
                            />
                        )}
                    </>
                )}
            </ProfileDetailsRow>
            <ProfileDetailsRow label="Time zone">
                <ProfileDetailsValue lines={[formatTimeZone(profile.timeZone)]} />
            </ProfileDetailsRow>
            <ProfileDetailsRow label="Address">
                <ProfileDetailsValue
                    lines={[
                        formatAddressStreet(profile.address),
                        formatAddressLocality(profile.address),
                    ]}
                />
            </ProfileDetailsRow>
            <ProfileDetailsRow label="Pronouns">
                <ProfileDetailsValue lines={[formatPronouns(profile.pronouns)]} />
            </ProfileDetailsRow>
        </dl>
    );
}
